import { SERVICE_GROUP_ID } from '@/constants';
import { isNewAndEditAndCancelOfHodaiPlusEnded } from '@/utils/date';

// GLOBIS 学び放題: 1, eMBA2.0: 2, GLOBIS 学び放題プラス（旧）: 3, GU: 7
export const isDisplaySubscriptionList = (serviceId: number) =>
  [1, 2, 3, 7].includes(serviceId);

export const isTransferredServiceGroupId = (serviceGroupId: number) =>
  [SERVICE_GROUP_ID.hodai, SERVICE_GROUP_ID.gu].includes(serviceGroupId);

/**
 * サービスの新規申込・編集・キャンセル操作が無効かどうかを判定
 * GLOBIS 学び放題プラス（旧）は2026-01-30以降、これらの操作ができない
 */
export const isSubscriptionActionDisabled = (serviceGroupId: number): boolean =>
  serviceGroupId === SERVICE_GROUP_ID.hodaiplus &&
  isNewAndEditAndCancelOfHodaiPlusEnded();

/**
 * 新規申込ボタンを表示すべきかどうかを判定
 */
export const isNewApplyButtonVisible = (serviceGroupId: number): boolean =>
  !isTransferredServiceGroupId(serviceGroupId) &&
  !isSubscriptionActionDisabled(serviceGroupId);
